import { IEventService } from '../interfaces/IEventService';

/**
 * Web Implementation of Event Service for user activity
 * Monitors DOM events to detect active user presence.
 */
export class WebEventService implements IEventService {
    private readonly activityEvents = ['mousemove', 'keydown', 'mousedown', 'touchstart'];

    subscribeToUserActivity(callback: () => void): () => void {
        if (typeof window === 'undefined') return () => { };

        const handler = () => callback();

        this.activityEvents.forEach((event) => {
            window.addEventListener(event, handler);
        });

        return () => {
            this.activityEvents.forEach((event) => {
                window.removeEventListener(event, handler);
            });
        };
    }
}
